import type { ReactNode } from 'react';
import { status, type StatusTone } from './tokens';

export interface StatusChipProps {
  tone: StatusTone;
  children: ReactNode;
}

/** Pill with a leading dot, coloured by tone (ok, warn, down, unk). */
export function StatusChip({ tone, children }: StatusChipProps) {
  const c = status[tone];
  return (
    <span
      data-tone={tone}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '2px 10px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: '20px',
        whiteSpace: 'nowrap',
        background: c.bg,
        color: c.fg,
      }}
    >
      <span
        aria-hidden
        style={{ width: 7, height: 7, borderRadius: '50%', background: 'currentColor' }}
      />
      {children}
    </span>
  );
}
